import React from 'react';
import { C } from './SettingsTokens';

export const BackIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10 3L5.5 8 10 13" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ChevronRight = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M5.5 3.5l4 4-4 4" stroke={C.textDim} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PersonIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <rect x="1.5" y="2.5" width="14" height="11" rx="2" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="6" cy="7.5" r="1.8" stroke="currentColor" strokeWidth="1.3"/>
    <path d="M2.5 13c.5-2 1.8-2.8 3.5-2.8s3 .8 3.5 2.8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M10.5 6.5h3M10.5 9.5h2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

export const LockIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path d="M5.5 7.5V5.5C5.5 3.567 6.843 2 8.5 2s3 1.567 3 3.5v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <rect x="2.5" y="7.5" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="8.5" cy="11.5" r="1.2" fill="currentColor"/>
    <path d="M8.5 12.5v1.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

export const TagIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path d="M9.3 1.7l5 5a2 2 0 010 2.82l-5.5 5.5a2 2 0 01-2.83 0l-5-5A2 2 0 010.6 8.6L1.7 3.3A2 2 0 013.3 1.7l5.3-1.1a2 2 0 01.7.1z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <circle cx="4.5" cy="4.5" r="1.2" fill="currentColor"/>
  </svg>
);

export const BellIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path d="M8.5 1.5A5 5 0 003.5 6.5v3l-1 1.5h12l-1-1.5v-3A5 5 0 008.5 1.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M6.5 11.5c0 1.1.9 2 2 2s2-.9 2-2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

export const ShieldIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path d="M8.5 1.5L2.5 3.5v5c0 3.3 2.7 5.8 6 6.5 3.3-.7 6-3.2 6-6.5v-5l-6-2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M6 8.5l1.5 1.5 3.5-3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PaletteIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <circle cx="8.5" cy="8.5" r="6.5" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="5.5" cy="7" r="1" fill="currentColor"/>
    <circle cx="8.5" cy="5" r="1" fill="currentColor"/>
    <circle cx="11.5" cy="7" r="1" fill="currentColor"/>
    <path d="M8.5 12.5c1.4 0 2.5-1 2.5-2.5H6c0 1.5 1.1 2.5 2.5 2.5z" fill="currentColor" opacity=".5"/>
  </svg>
);

export const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M11 2H13a1 1 0 011 1v10a1 1 0 01-1 1H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 11l4-3-4-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 8H2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
